import { ASPECT_RATIO_OPTIONS } from '../../ClipCustomizer/Layout/constants';
import { SizeType } from '@/domains/asset';
import TooltipV2 from '@/components/TooltipV2';

const ClipCustomizerAspectRatioTooltip = ({ hoveringAspectRatio }: { hoveringAspectRatio: SizeType | null }) => {
  return (
    <TooltipV2
      tooltipContent={hoveringAspectRatio ? (ASPECT_RATIO_OPTIONS[hoveringAspectRatio]?.helpText ?? '') : ''}
      place={'left'}
      tooltipId="aspect-ratio-tooltip"
      size="base"
      colorTheme="light"
      className="!px-3 !py-1.5 !text-sm"
      opacity={1}
      offset={24}
    />
  );
};

export default ClipCustomizerAspectRatioTooltip;
